module.exports = __webpack_public_path__ + "/images/logo-ebay-it.7590807.png";